<template>
  <ul :class="$style.list">
    <li
      v-for="item in list"
      :class="[
        $style.item,
        { [$style['item--selected']]: item.guid === modelValue },
      ]"
      :key="item.guid"
      @click="emit('update:modelValue', item.guid)"
    >
      {{ item.label }}
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { ChatMessageTemplate } from '@/types/app'

defineProps<{
  list: ChatMessageTemplate[]
  modelValue: Maybe<ChatMessageTemplate['guid']>
}>()

const emit = defineEmits<{
  (event: 'update:modelValue', value: ChatMessageTemplate['guid']): void
}>()
</script>

<style lang="scss" module>
.item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 12px;
  font-weight: 600;
  word-break: break-all;
  border-bottom: solid 1px $color-border-low-emphasis;

  &--selected {
    background: $color-background-base;
  }

  &:hover {
    cursor: pointer;
    background: $color-background-base;
  }
}
</style>
